import React from 'react';
import { Box, Typography } from '@mui/material';

import { hasTrussDesignPermission } from '@paragon/login-tools';
import { getSpinnersToDisplay } from '@paragon/task-spinner';

import { getSaveStatus } from '../../../store/selectors/saveSelectors';
import { useAppSelector } from '../../hooks';

export function SaveStatusIndicator() {
  const saveStatus = useAppSelector(getSaveStatus);
  const spinnerActive = useAppSelector((state) => getSpinnersToDisplay(state).size > 0);

  const visible = useAppSelector(hasTrussDesignPermission);

  if (!visible) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingX: 1,
      }}
    >
      {/* all three possible messages are kept rendered so this indicator stays the same width at all times */}

      <Typography
        variant="body2"
        color="textSecondary"
        sx={saveStatus === 'error' ? { color: 'error.light' } : { visibility: 'hidden', height: 0 }}
      >
        Error saving changes
      </Typography>

      <Typography
        variant="body2"
        color="textSecondary"
        sx={
          saveStatus === 'saving' || (spinnerActive && saveStatus !== 'error')
            ? {}
            : {
                visibility: 'hidden',
                height: 0,
              }
        }
      >
        Working...
      </Typography>

      <Typography
        variant="body2"
        color="textSecondary"
        sx={
          saveStatus === 'saved' && !spinnerActive
            ? {}
            : {
                visibility: 'hidden',
                height: 0,
              }
        }
      >
        All changes saved
      </Typography>
    </Box>
  );
}
